<template>
  <div class="notification_frame  fx fdc">
    <Header :title="$tp('header.title.notification')"></Header>
    <div class="_fill">
      <div class="notification_ctn" v-for="item in 10">
        <div class="title_box">
          <div class="title">好友電充電管家</div>
          <div class="image_box _channel">
            <div v-if="item.imageUrl" class="image" :style="{backgroundImage: `url(${item.imageUrl})`}"></div>
            <el-avatar v-else :size="24" :src="require('@/assets/img/default_channel.svg')"></el-avatar>
          </div>
        </div>
        <div class="status">充電樁降載</div>
        <div class="content">充電樁[充電樁編號]已離線，請確認該充電樁是否有正常通電。所屬住宅 [住宅名稱]，用戶 [用戶名稱]</div>
        <div class="date">2025/01/12 上午4:09</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mixins: [],
}
</script>

<style lang="scss" scoped>
.notification_frame {
  height: 100%;
  background-color: $gray_95;
  .notification_ctn {
    @include buttonEnhance();
    background-color: #ffffff;
    border-bottom: 1px solid $gray_90;
    padding: 0.8rem 1rem;
    .title_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 80%;
      }
      .image_box {
        @include image-box(1.4rem);
      }
    }
    .status {
      font-size: 70%;
      margin-top: 0.2rem;
    }
    .content {
      font-size: 70%;
      margin-top: 0.1rem;
      color: $gray_60;
    }
    .date {
      font-size: 70%;
      text-align: right;
      color: $gray_70;
      letter-spacing: 0;
    }
  }
}
</style>